export const getBoatName = (boat: {
  year_first?: number | null;
  model?: string | null;
  manufacturer?: {
    name?: string;
  };
}): string => {
  let boatName = boat?.year_first?.toString() || '';
  const manufacturer = boat?.manufacturer?.name;

  boatName += ` ${manufacturer ? manufacturer : ''}`;
  boatName += ` ${boat?.model}` || '';

  return boatName;
};
